<template>
  <div class="page-pc">
    <img src="~@static/fundingnew_/pc_1.png" alt="" class="qr">
    <page-footer></page-footer>
  </div>
</template>

<script>
import PageFooter from '@components/PageFooter'

export default {
  name: 'Protocol',
  components: {
    PageFooter,
  },
}
</script>

<style lang="scss" scoped>
.page-pc {
  height: 100%;
  background: url('~@static/fundingnew_/pc_index.jpg') no-repeat;
  background-size: cover;
}
.qr {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -60%);
  height: (546/900 * 100) * 1vh;
}
.page-footer {
  position: absolute !important;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/Pc.vue